module.exports = __webpack_public_path__ + "img/Scenarios_Adaptive_Innovation.fce67593.jpg";